import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import store from "@/store";
import * as firebase from "firebase/app";
import "firebase/auth";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Top",
    component: () => import("../views/Top.vue"),
  },
  {
    path: "/signup",
    name: "Signup",
    component: () => import("../views/Signup.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/logout",
    name: "Logout",
    component: () => import("../views/Logout.vue"),
  },
  {
    path: "/signup-not-valid",
    name: "SignupNotValid",
    component: () => import("../views/SignupNotValid.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/password/reset",
    name: "PasswordReset",
    component: () => import("../views/PasswordReset.vue"),
  },
  {
    path: "/password/set-email",
    name: "PasswordSet",
    component: () => import("../views/PasswordSet.vue"),
  },
  {
    path: "/password/set-email/done",
    name: "PasswordSetDone",
    component: () => import("../views/PasswordSetDone.vue"),
  },
  {
    path: "/terms",
    name: "Terms",
    component: () => import("../views/Terms.vue"),
  },
  {
    path: "/privacy-policy",
    name: "PrivacyPolicy",
    component: () => import("../views/PrivacyPolicy.vue"),
  },
  {
    path: "/:salon_id/about",
    name: "About",
    component: () => import("../views/About.vue"),
    meta: { customHeader: true, storageURL: true, salonID: true }
  },
  {
    path: "/trading",
    name: "Trading",
    component: () => import("../views/About.vue"),
    meta: { storageURL: true }
  },
  {
    path: "/order/cart/:salon_id/:ticket_id",
    name: "TicketBuyOrder",
    component: () => import("../views/TicketBuyOrder.vue"),
    meta: { customHeader: true, requiresAuth: true, salonID: true },
  },
  {
    path: "/order/cart/:salon_id/:ticket_id/check",
    name: "TicketBuyCheck",
    component: () => import("../views/TicketBuyCheck.vue"),
    meta: { customHeader: true, requiresAuth: true, salonID: true },
  },
  {
    path: "/order/done/:salon_id/:ticket_id",
    name: "TicketBuyDone",
    component: () => import("../views/TicketBuyDone.vue"),
    meta: { customHeader: true, requiresAuth: true, salonID: true },
  },
  {
    path: "/mypage/favorite-salon",
    name: "SalonFavorite",
    component: () => import("../views/SalonFavorite.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/mypage/browsing-salon",
    name: "SalonHistory",
    component: () => import("../views/SalonHistory.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/mypage/buyed-service/:purchased_ticket_id",
    name: "TicketUse",
    component: () => import("../views/TicketUse.vue"),
    meta: { customHeader: true, requiresAuth: true },
  },
  {
    path: "/mypage/buyed-service",
    name: "TicketBuyed",
    component: () => import("../views/TicketBuyed.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/mypage/favorite-service",
    name: "TicketFavorite",
    component: () => import("../views/TicketFavorite.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/mypage/profile",
    name: "SettingProfile",
    component: () => import("../views/SettingProfile.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/mypage/email",
    name: "SettingEmail",
    component: () => import("../views/SettingEmail.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/mypage/password",
    name: "SettingPassword",
    component: () => import("../views/SettingPassword.vue"),
    meta: { requiresAuth: true },
  },
  // {
  //   path: "/mypage/credit-card",
  //   name: "SettingCreditCard",
  //   component: () => import("../views/SettingCreditCard.vue"),
  //   meta: { requiresAuth: true },
  // },
  {
    path: "/mypage/deactivate",
    name: "SettingDeactivate",
    component: () => import("../views/SettingDeactivate.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/:salon_id",
    name: "SalonDetail",
    component: () => import("../views/SalonDetail.vue"),
    meta: { customHeader: true, storageURL: true, salonID: true },
  },
  {
    path: "/:salon_id/service",
    name: "SalonTicket",
    component: () => import("../views/SalonTicket.vue"),
    meta: { customHeader: true, storageURL: true, salonID: true },
  },
  {
    path: "/:salon_id/qr-redirect",
    name: "QrRedirect",
    component: () => import("../views/QrRedirect.vue"),
    meta: { customHeader: true, storageURL: true, salonID: true },
  },
  {
    path: "/:salon_id/service/:ticket_id",
    name: "TicketDetail",
    component: () => import("../views/TicketDetail.vue"),
    meta: { customHeader: true, storageURL: true, salonID: true },
  },
  {
    path: "/secret_sale/:secret_sale_token",
    name: "SecretServiceList",
    component: () => import("../views/SecretServiceList.vue"),
    meta: { customHeader: true, storageURL: true },
  },
  {
    path: "/secret_sale/:secret_sale_token/service/:ticket_id",
    name: "SecretServiceDetail",
    component: () => import("../views/TicketDetail.vue"),
    meta: { customHeader: true, storageURL: true },
  },
  {
    path: "/secret_sale/order/cart/:secret_sale_token/:ticket_id",
    name: "SecretServiceBuyOrder",
    component: () => import("../views/TicketBuyOrder.vue"),
    meta: { customHeader: true, requiresAuth: true },
  },
  {
    path: "/secret_sale/order/cart/:secret_sale_token/:ticket_id/check",
    name: "SecretServiceBuyCheck",
    component: () => import("../views/TicketBuyCheck.vue"),
    meta: { customHeader: true, requiresAuth: true },
  },
  {
    path: "/auth/action",
    name: "AuthMode",
    component: () => import("../views/auth/Index.vue"),
  },
  {
    path: "*",
    name: "NotFound",
    component: () => import("../views/NotFound.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.salonID)) {
    store.dispatch("actionSetSalonId", String(to.params.salon_id));
  };
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    firebase.auth().onAuthStateChanged((user) => {
      if (!user) {
        next({
          name: "Login",
        });
      } else {
        const providerData = user.providerData;
        if (providerData) {
          // すべての認証プロバイダーを調べる
          for (const userProviderData of providerData) {
            if (userProviderData) {
              // メールアドレス認証だったらメール認証状態をチェック
              if (userProviderData.providerId == "password" || userProviderData.providerId == "google.com") {
                // 必要に応じてメール認証確認画面に遷移
                if (!user.emailVerified) {
                  if (from.name == "SignupNotValid") {
                    // メール認証が終わるまで他の画面に遷移させない
                    return;
                    // 無限ループ回避のためメール認証確認画面への遷移は対象外とする
                  } else if (to.name != "SignupNotValid") {
                    next({
                      name: "Login",
                    });
                  } else {
                    next();
                  }
                } else if (from.name == "Login" || from.name == "Signup") {
                  next();
                } else if (store.getters.user && store.getters.user.custom_id) {
                  next();
                // } else if (to.name != "SettingProfile") {
                //   localStorage.activeMessage == true;
                //   window.location.href = "/mypage/profile";
                } else {
                  next();
                }
              }
            }
          }
        }
        next();
      }
    });
  } else {
    if (to.name == "Login" || to.name == "Signup" || to.name == "Home") {
      firebase.auth().onAuthStateChanged((user) => {
        if (localStorage.login == "true") {
          localStorage.login = "false";
          next();
        // } else if (user) {
        //   next({ name: "SalonHistory" });
        } else {
          next();
        }
      });
    } else {
      next();
    }
  }
});

router.afterEach((to) => {
  if (to.meta && to.meta.customHeader) {
    store.dispatch("actionSetHeaderUrl", "/loading.gif");
  } else {
    store.dispatch("actionSetHeaderUrl", "/logo.svg");
  }

  if (to.meta && to.meta.storageURL) {
    localStorage.path = to.path;
  }
});

export default router;
